// THIS IS THE WEBSOCKET PINGER

export const onCreateTransaction = `
  subscription OnCreateTransaction {
    onCreateTransaction {
      createdAt
      date_created
      date_released
      date_updated
      document_name
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      id
      document_price
      full_name
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
     

    }
  }
`;

export const onUpdateTransaction = `
  subscription OnUpdateTransaction {
    onUpdateTransaction {
      createdAt
      date_created
      date_released
      date_updated
      document_name
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      id
      document_price
      full_name
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
     
    }
  }
`;

export const onDeleteTransaction = `
  subscription OnDeleteTransaction {
    onDeleteTransaction {
      createdAt
      date_created
      date_released
      date_updated
      document_name
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      id
      document_price
      full_name
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
     
    }
  }
`;


// // USER LOGS
export const onCreateUserStatus = `
  subscription onCreateUserStatus {
    onCreateUserStatus {
      id
      user_profile_id
      user_status
      full_name
      user_profile_photo
      user_location {
        latitude
        longitude
      }
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateUserStatus = `
  subscription onUpdateUserStatus {
    onUpdateUserStatus {
      id
      user_profile_id
      user_status
      full_name
      user_profile_photo
      user_location {
        latitude
        longitude
      }
      createdAt
      updatedAt
    }
  }
`;


// TRANSACTION LAWYER
export const onCreateTransactionLawyer = `
  subscription onCreateTransactionLawyer {
    onCreateTransactionLawyer {
      createdAt
      created_by
      date_created
      date_updated
      document_price
      document_status
      id
      lawyer_name
      transaction_id
      transaction_status
      transaction_type
      updatedAt
      updated_by
      user_profile_id
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;

export const onUpdateTransactionLawyer = `
  subscription onUpdateTransactionLawyer {
    onUpdateTransactionLawyer {
      createdAt
      created_by
      date_created
      date_updated
      document_price
      document_status
      id
      lawyer_name
      transaction_id
      transaction_status
      transaction_type
      updatedAt
      updated_by
      user_profile_id
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;

export const onDeleteTransactionLawyer = `
  subscription onDeleteTransactionLawyer {
    onDeleteTransactionLawyer {
      createdAt
      created_by
      date_created
      date_updated
      document_price
      document_status
      id
      lawyer_name
      transaction_id
      transaction_status
      transaction_type
      updatedAt
      updated_by
      user_profile_id
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;



// CHAT
export const onCreateChatMessage = `
  subscription OnCreateChatMessage {
    onCreateChatMessage {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
      transaction_id
    }
  }
`;

export const onUpdateChatMessage = `
  subscription OnUpdateChatMessage {
    onUpdateChatMessage {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
      transaction_id
    }
  }
`;

export const onDeleteChatMessage = `
  subscription OnDeleteChatMessage {
    onDeleteChatMessage {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
      transaction_id
    }
  }
`;

// CHAT NEGOTIATION NOT CHAT MESSAGES
export const onUpdateChatNegotiation = `
  subscription OnUpdateChatNegotiation {
    onUpdateChatNegotiation {
      id
      status
      lawyer_id
      transaction_id
      date_created
      createdAt
      updatedAt
    }
  }
`;




// CHAT NEGOTIATION NOT CHAT MESSAGES
export const onUpdateWitnessTransaction = `
  subscription OnUpdateChatNegotiation {
    onUpdateChatNegotiation {
      id
      transaction_id
      contact_info
      participant_type
      signature
      created_by
      date_created
      date_updated
      updated_by
      transaction_status
      valid_id
      createdAt
      updatedAt
    }
  }
`;




// USER IS IN VIDEOCON
export const onCreateTransactionVideoConference = `
  subscription onCreateTransactionVideoConference {
    onCreateTransactionVideoConference {
      id
      transaction_id
      user_id
      user_tag
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateTransactionVideoConference = `
  subscription onUpdateTransactionVideoConference {
    onUpdateTransactionVideoConference {
      id
      transaction_id
      user_id
      user_tag
      createdAt
      updatedAt
    }
  }
`;


export const onDeleteTransactionVideoConference = `
  subscription onDeleteTransactionVideoConference {
    onDeleteTransactionVideoConference {
      id
      transaction_id
      user_id
      user_tag
      createdAt
      updatedAt
    }
  }
`;

